import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-ng2-link',
  templateUrl: './ng2-link.component.html',
  styleUrls: ['./ng2-link.component.scss']
})
export class Ng2LinkComponent implements OnInit {
  @Input() to: string;

  constructor() {}

  ngOnInit() {}
}
